import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Share2, Download } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { publicUrl, whatsappLink } from "@/lib/format";
import ThanksAnimation from "@/components/ask/ThanksAnimation";

async function makeCard(style, from) {
  const c = document.createElement("canvas");
  c.width = 1080; c.height = 1350;
  const g = c.getContext("2d");
  const bg = { playful: ["#ECFDF5", "#FEF3C7"], friendly: ["#FDF2F8", "#FFE4E6"], formal: ["#FBF8F1", "#F5E9D3"] }[style] || ["#ECFDF5", "#FEF3C7"];
  const grad = g.createLinearGradient(0, 0, 0, 1350); grad.addColorStop(0, bg[0]); grad.addColorStop(1, bg[1]);
  g.fillStyle = grad; g.fillRect(0, 0, 1080, 1350);
  g.textAlign = "center";
  g.font = "260px serif"; g.fillText({ playful: "🎉", friendly: "🤗", formal: "🏅" }[style] || "🎉", 540, 560);
  g.fillStyle = style === "formal" ? "#92400E" : "#0D4736";
  g.font = "800 92px Outfit, sans-serif"; g.fillText("Thank you!", 540, 790);
  g.font = "600 46px 'Plus Jakarta Sans', sans-serif"; g.fillStyle = "#4B5563"; g.fillText(`— ${from}`, 540, 870);
  g.font = "700 34px Outfit, sans-serif"; g.fillStyle = "#0D4736"; g.fillText("Made with Debii", 540, 1270);
  return new Promise((r) => c.toBlob(r, "image/png"));
}

export default function PublicThanks() {
  const { token } = useParams();
  const [t, setT] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/t/${token}`).then(({ data }) => setT(data)).catch(() => setErr(true));
  }, [token]);

  if (err) return <div data-testid="thanks-invalid" className="min-h-[100dvh] flex items-center justify-center p-8 text-center text-muted-foreground">This thank-you link isn't available.</div>;
  if (!t) return <div className="min-h-[100dvh] bg-emerald-50" />;

  const share = async () => {
    const url = publicUrl(`/api/s/${token}`);
    if (navigator.share) {
      try { await navigator.share({ title: "Debii Thanks", url }); return; } catch (e) { if (e?.name === "AbortError") return; }
    }
    window.open(whatsappLink(null, `I got a Debii Thanks 💚 ${url}`), "_blank", "noopener");
  };
  const save = async () => {
    const blob = await makeCard(t.style, t.from_name);
    const file = new File([blob], "debii-thanks.png", { type: "image/png" });
    if (navigator.canShare?.({ files: [file] })) {
      try { await navigator.share({ files: [file] }); return; } catch (e) { if (e?.name === "AbortError") return; }
    }
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob); a.download = "debii-thanks.png"; a.click();
    toast.success("Thank-you card saved");
  };

  return (
    <div className="relative mx-auto max-w-[30rem]">
      <ThanksAnimation style={t.style} to={t.to_name} from={t.from_name} />
      <div className="absolute inset-x-0 bottom-0 px-6 pb-[max(1.5rem,env(safe-area-inset-bottom))]">
        <div className="flex gap-2">
          <button data-testid="thanks-save-card" onClick={save} className="flex-1 h-12 rounded-2xl bg-white/90 backdrop-blur border border-black/5 text-sm font-semibold flex items-center justify-center gap-2 active:scale-[0.98] transition-transform">
            <Download className="h-4 w-4" /> Save card
          </button>
          <button data-testid="thanks-share" onClick={share} className="flex-1 h-12 rounded-2xl bg-primary text-primary-foreground text-sm font-semibold flex items-center justify-center gap-2 active:scale-[0.98] transition-transform">
            <Share2 className="h-4 w-4" /> Share
          </button>
        </div>
        <Link to="/welcome" data-testid="thanks-made-with-debii" className="mt-4 block text-center text-xs font-semibold text-muted-foreground">
          Made with <span className="font-display font-extrabold text-primary">Debii</span>
        </Link>
      </div>
    </div>
  );
}
